import { FormattedMessage, injectIntl } from "react-intl";
import { accessRightsShape, intlShape } from "../../shapes";
import List from "../List/List";
import AssetItem from "./AssetItem";
import Hint from "../Hint";

type Props = {
  accessRights?: accessRightsShape;
  intl: intlShape;
  assets?: $TSFixMe;
};

export function AssetComponentsList(props: Props) {
  const { intl, accessRights, assets } = props;

  return (
    <div id="asset-list">
      <h2>
        <FormattedMessage id="child_asset_list.header" />
      </h2>
      {assets.length > 0 ? (
        <List id="assets_assign_list">
          {/* @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type. */}
          {assets.map((el) => (
            <AssetItem
              key={(el as $TSFixMe).id}
              // @ts-expect-error TS(2322) FIXME: Type '{ key: any; asset: any; showItemMenu: boolea... Remove this comment to see the full error message
              asset={el}
              showItemMenu={false}
              parentAccessRights={accessRights}
            />
          ))}
        </List>
      ) : (
        <Hint
          id="hint-no-assets-assigned"
          details={intl.formatMessage({ id: "asset_list.no_assets_assign" })}
        />
      )}
    </div>
  );
}
export default injectIntl(AssetComponentsList);
